export default class Iovation {
	public constructor(container: HTMLFormElement, brandName: string) {
		const hiddenInputField: HTMLInputElement = document.createElement('input');
		hiddenInputField.type = 'hidden';
		hiddenInputField.name = 'fd';
		hiddenInputField.classList.add('fd');
		container.prepend(hiddenInputField);

		const iovationScript: HTMLScriptElement = document.createElement(
			'SCRIPT'
		) as HTMLScriptElement;
		iovationScript.src = `/static_cms/${brandName}/static/peg_utils/iovation/iovation.js`;
		document.body.appendChild(iovationScript);
	}
}
